import React from 'react'
// import PropTypes from 'prop-types'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

const Footer = props => {
	return (
		<footer>
			<Container>
				<Row>
					<Col className="text-center py-3">Copyright &copy; 2020</Col>
				</Row>
			</Container>
		</footer>
	)
}

Footer.propTypes = {
	//
}

export default Footer
